
export default {
    setUpSimViews(views, detailColumns, documentTypes, documentStatuss, page) {
        let defaultViews = [
            {
                name: "Job Title Analysis – Similarity",
                name_match: "different_name",
                content_match: "similar_content",
            },
            {
                name: "Job Title Analysis – Differences",
                name_match: "same_name",
                content_match: "different_content",
            },
            {
                name: "Job Title Analysis – Duplicates",
                name_match: "same_name",
                content_match: "similar_content",
            },
            //   {
            //     name: _newTitle,
            //     name_match: "same_name",
            //     content_match: "similar_content",
            //   },
            {
                name: "Linked Documents",
                name_match: null,
                content_match: null,
                linked_doc_view: true,
            },
        ];
        detailColumns.push({
            value: "match_pct_content_max",
            text: "Max Match %",
            type: "Number",
        });
        //   if (views.length < defaultViews.length) {
        let defaultTempsForLinked = documentTypes
            .filter((x) => x.docType.toLowerCase().indexOf("prof") > 0)
            .map((t) => t.tmpl_id);
        let tmpl = documentTypes.find(
            (x) => x.docType.toLowerCase().indexOf("desc") > 0
        );
        if (!tmpl)
            tmpl = documentTypes.find(
                (x) => x.docType.toLowerCase().indexOf("prof") > 0
            );
        if (!tmpl) tmpl = documentTypes[0];
        if (!defaultTempsForLinked.length)
            defaultTempsForLinked.push(tmpl.tmpl_id);
        let defaultStatuss = documentStatuss
            .filter(
                (x) => x.tmpl_id === tmpl.tmpl_id && x.doc_status_type === "APPROVED"
            )
            .map((x) => x.doc_status_text);
        let defaultColumns = [
            "doc_name",
            "doc_status_text",
            "advert_job_title",
            ...detailColumns
                .filter((c) => c.value.indexOf("hry") === 0)
                .map((c) => c.value),
        ];
        //check for defaults
        defaultViews
            .filter((x) => !views.some((v) => v.name === x.name))
            .forEach((x) => {
                let view = {
                    view_definition_id: null,
                    view_type: page,
                    name: x.name,
                    restricted: false,
                    definition: {
                        tmpl_id: tmpl.tmpl_id,
                        templates: x.linked_doc_view ? defaultTempsForLinked : [],
                        statuses: defaultStatuss,
                        columnsVisible: defaultColumns,
                        matchLevels: [],
                        name_match: x.name_match,
                        content_match: x.content_match,
                        linked_doc_view: !!x.linked_doc_view,
                        columnFilters: [],
                    },
                };
                if (
                    x.linked_doc_view &&
                    !view.definition.columnsVisible.some((x) => x === "doc_type")
                )
                    view.definition.columnsVisible.push("doc_type");
                views.push(view);
            });
        //   }
        views.forEach((v) => {
            v.isDirty = false;
            v.canSave = true;
            this.setViewTitle(v);
        });
        this.sortViews(views);
        return views;
    },
    demoMatchHack(parentName, doc, index) {
      let randomMatchPcts_oood = [92, 97, 96, 98, 99, 93, 95, 91, 90, 96];
      let randomMatchPcts_ok = [77, 80, 72, 66, 79, 61, 74, 69, 67, 87];
      let randomMatchPcts_bad = [45, 38, 33, 49, 29, 44, 48, 39, 47, 40];

      let id = index % 5;
      if (id < 2) 
        return { pct: randomMatchPcts_oood[index], colour: "purple" };
      else if (id > 3) 
        return { pct: randomMatchPcts_bad[index], colour: "blue" };
      else
        return { pct: randomMatchPcts_ok[index], colour: "indigo" };

      // let editDistance = (s1, s2) => {
      //   s1 = s1.toLowerCase();
      //   s2 = s2.toLowerCase();

      //   let costs = new Array();
      //   for (let i = 0; i <= s1.length; i++) {
      //     var lastValue = i;
      //     for (let j = 0; j <= s2.length; j++) {
      //       if (i == 0) costs[j] = j;
      //       else {
      //         if (j > 0) {
      //           let newValue = costs[j - 1];
      //           if (s1.charAt(i - 1) != s2.charAt(j - 1))
      //             newValue =
      //               Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
      //           costs[j - 1] = lastValue;
      //           lastValue = newValue;
      //         }
      //       }
      //     }
      //     if (i > 0) costs[s2.length] = lastValue;
      //   }
      //   return costs[s2.length];
      // };
      // let similarity = (s1, s2) => {
      //   let longer = s1;
      //   let shorter = s2;
      //   if (s1.length < s2.length) {
      //     longer = s2;
      //     shorter = s1;
      //   }
      //   let longerLength = longer.length;
      //   if (longerLength === 0) {
      //     return 1.0;
      //   }
      //   return (
      //     (longerLength - editDistance(longer, shorter)) /
      //     parseFloat(longerLength)
      //   );
      // };
      // let child = doc.detail ? doc.detail.advert_job_title || "" : "";
      // let pct = Math.round(similarity(parentName, child) * 100) / 1;
      // if (pct === 100) 
      //   return { pct: randomMatchPcts_oood[index], colour: "purple" };
      // else if (pct < 50) 
      //   return { pct: randomMatchPcts_bad[index], colour: "blue" };
      // else
      //   return { pct: randomMatchPcts_ok[index], colour: "indigo" };
    },
    prepareSimDocs(docs, hierarchyTypes, statsOnly, linkedDocSimilarityRequired, use) {
        // const relatedDocs = docs.filter(x => x.relationships?.length).reduce((p,c) => p = [ ...p, ...c.relationships.map(x => x.doc_id) ], []);
        let allDocs = docs.map(x => { return {...x}; });
        allDocs.forEach(doc => {
            delete doc.matches_different_content_same_name;
            delete doc.matches_similar_content_different_name;
            delete doc.matches_similar_content_same_name;
            doc.tmpl_id = Number(doc.tmpl_id);
        });
        let matchColumn;
        let matchLevels = [];
        const getColumnValue = (data, column) => {
            if (data.detail) {
                if (data.detail.detail) return data.detail.detail[column];
                return data.detail[column];
            }
            return data[column];
        }
        if (allDocs.length && allDocs[0].job_code !== undefined) {
            matchColumn = "job_code";
            matchLevels.push({
                name: "Same Job Code",
                title: "Job Code",
                matchColumn: matchColumn,
                matchFunction: (d, dm, column) => getColumnValue(dm, column) === getColumnValue(d, column),
            });
        }
        hierarchyTypes.forEach((ht) => {
            let prev = "";
            for (let l = 1; l <= ht.linklevel; l++) {
                let lname = ht.h_levels?.length ? ht.h_levels[l - 1] : ht[`level${l}_name`];
                prev += (prev.length ? " - " : "") + lname;
                matchColumn = `ht${ht.ht_id}l${l}`;
                matchLevels.push({
                    name: `Same ${prev}`,
                    title: prev,
                    matchColumn: matchColumn,
                matchFunction: (d, dm, column) => getColumnValue(dm, column) === getColumnValue(d, column),
                });
                matchLevels.push({
                    name: `Different ${prev}`,
                    title: prev,
                    matchColumn: matchColumn,
                matchFunction: (d, dm, column) => getColumnValue(dm, column) !== getColumnValue(d, column),
                });
            }
        });
        let stats = [];
        allDocs.forEach((d) => {
            if (
                !stats.some(
                    (s) =>
                        s.tmpl_id === d.tmpl_id && s.doc_status_text === d.doc_status_text
                )
            ) {
                stats.push({
                    tmpl_id: d.tmpl_id,
                    doc_status_text: d.doc_status_text,
                    doc_status_type: d.doc_status,
                });
            }
            if (!statsOnly) {
                hierarchyTypes.forEach((ht) => {
                    if (d.hierarchies) {
                        let dh = d.hierarchies.find((x) => x.ht_id === ht.ht_id);
                        if (dh) {
                            let prev = "";
                            let targetIndex = 1;
                            for (let li = ht.linklevel; li >= 1; li--) {
                                d[`ht${ht.ht_id}l${targetIndex}`] = prev + dh[`hierarchy${li}`];
                                prev = dh[`hierarchy${li}`] + "|";
                                targetIndex++;
                            }
                        }
                    } else {
                        if (d[`ht_${ht.ht_id}`]) {
                            let prev = "";
                            for (let li = 1; li <= ht.linklevel; li++) {
                                d[`ht${ht.ht_id}l${li}`] = prev + d[`ht_id_${ht.ht_id}_${li}_`];
                                prev = d[`ht${ht.ht_id}l${li}`] + "|";
                            }
                        }
                    }
                });
            }
        });
        if (!statsOnly) {
            let cleanDocs = allDocs.map(x => { return {...x}; });
            cleanDocs.forEach(doc => {
                delete doc.matches;
            });
            allDocs.forEach((d) => {
                d.matches.forEach(
                    (dm) => dm.detail = cleanDocs.find((x) => x.doc_id === dm.doc_id)
                );
                d.matches = d.matches.filter((x) => x.detail);
                if (d.relationships) {
                    d.relationships.forEach((dr, di) => {
                        dr.detail = cleanDocs.find((x) => x.doc_id === dr.doc_id);
                        let kack = linkedDocSimilarityRequired ? this.demoMatchHack(d.advert_job_title || d.doc_name, dr, di) : null;
                        dr.match_pct_content = kack?.pct || null;
                        dr.match_pct_content_colour = kack?.colour || null;
                    });
                    d.relationships = d.relationships.filter((x) => x.detail);
                }
                d.expanded = false;
                d.selected = false;
            });
        }

        return {
            matchLevels: matchLevels,
            // matchDocs: statsOnly ? null : allDocs.filter((d) => d.matches?.length),
            // relatedDocs: statsOnly ? null : allDocs.filter((d) => d.relationships?.length),
            documents: statsOnly ? null : allDocs.filter((d) => d.relationships?.length || d.matches?.length),
            docStatuss: stats,            
            similarityColumnsName: [
                { label: "Same Title", column: "same_name" },
                { label: "Similar Title", column: "similar_name" },
                { label: "Different Title", column: "different_name" },
                { label: "Ignore Title", column: "ignore_name" },
            ],
            similarityColumnsContent: [
                { label: "Same Content", column: "same_content" },
                { label: "Similar Content", column: "similar_content" },
                { label: "Different Content", column: "different_content" },
                { label: "Ignore Content", column: "ignore_content" },
            ],
        };
    },
    setViewTitle(view) {
        view.title = view.name + (view.restricted ? " (My report)" : "");
    },
    sortViews(views) {
        views.sort((a, b) =>
            a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
        );
    },
    changeSimDocType(ViewDef, ViewData) {
        let docStatusList = [];
        let statuses = [];
      if (ViewDef.linked_doc_view) {
        ViewData.docStatuss.forEach((s) => {
          if (
            ViewDef.templates.some(
              (t) => t === s.tmpl_id
            ) &&
            !docStatusList.some((l) => l.doc_status_text === s.doc_status_text)
          )
            docStatusList.push(s);
        });
      } else {
        docStatusList = ViewData.docStatuss.filter(
          (s) => s.tmpl_id === ViewDef.tmpl_id
        );
      }
      let currentStats = ViewDef.statuses.map(
        (s) => s
      );
      statuses = docStatusList
        .filter((s) => currentStats.some((x) => x === s.doc_status_text))
        .map((s) => s.doc_status_text);
      if (statuses.length === 0) {
        statuses = docStatusList
          .filter((s) => s.doc_status_type === "APPROVED")
          .map((s) => s.doc_status_text);
      }
      if (statuses.length === 0) {
        statuses = docStatusList
          .filter((s) => s.doc_status_type === "PENDING")
          .map((s) => s.doc_status_text);
      }
      if (statuses.length === 0) {
        statuses = docStatusList
          .filter((s) => s.doc_status_type === "DRAFT")
          .map((s) => s.doc_status_text);
      }
      ViewDef.statuses = statuses;
      ViewData.docStatusList = docStatusList;
    },
    getDescription(selectedView, documentTypes, similarityColumnsName, similarityColumnsContent) {
      if (!selectedView) return "Please select a report";
      let def = selectedView;
      let docType = def.linked_doc_view
        ? def.templates
            .map(
              (t) =>
                documentTypes.find((dt) => dt.tmpl_id === t).docType + "s"
            )
            .join(", ")
        : documentTypes.find((t) => t.tmpl_id === def.tmpl_id).docType +
          "s";
      let desc = `${docType} in ${def.statuses
        .map(
          (s, si) =>
            s +
            (def.statuses.length > 1 && si < def.statuses.length - 1
              ? si === def.statuses.length - 2
                ? " or "
                : ", "
              : "")
        )
        .join("")} status with ${
        similarityColumnsName.find((c) => c.column === def.name_match)
          ?.label || "linked documents"
      }  ${def.linked_doc_view ? "" : "and"}  ${
        similarityColumnsContent.find(
          (c) => c.column === def.content_match
        )?.label || ""
      }`;
      if (def.matchLevels.length) {
        desc += ` matching on ${def.matchLevels
          .map(
            (s, si) =>
              s +
              (def.matchLevels.length > 1 && si < def.matchLevels.length - 1
                ? si === def.matchLevels.length - 2
                  ? " and "
                  : ", "
                : "")
          )
          .join("")}`;
      }
      return desc;
    },    
    distinctValues (arr, keys) {
        let list = [];
        arr.forEach(function (item) {
          let row = list.filter(function (li) {
            let match = true;
            keys.forEach(function (k) {
              if (li[k] !== item[k]) match = false;
            });
            return match;
          })[0];
          if (!row) {
            row = { _count: 1 };
            keys.forEach(function (k) {
              row[k] = item[k];
            });
            list.push(row);
          } else {
            row._count++;
          }
        });
        return list;
    },
    getFilterValues(rows, columnDef, preset) {     
        let isNumber = false;   
        let isActive = false;
        let column = columnDef.value || columnDef.display_column || columnDef.column;
        let getSort = () => {
            if (isNumber) {
                return (a, b) => (a > b ? 1 : a < b ? -1 : 0);
            } else {
                return (a, b) => {
                const at = a.text?.toLowerCase().trim() || "";
                const bt = b.text?.toLowerCase().trim() || "";
                return at > bt ? 1 : at < bt ? -1 : 0;
                };
            }
        };
        let values = this.distinctValues(rows, [column])
          .map((x, xi) => {
            let text = x[column];
            if (text === undefined || text === null) {
              text = "";
            }
            let searchText = text;
            let selected =
              preset &&
              preset.filterSettings.values.some(
                (p) => p.selected && p.value === text
              );
            if (selected) isActive = true;
            isNumber = columnDef.type === "Number" || typeof searchText === "number";
            return {
              text: text,
              value: text,
              selected: selected,
              visible: true,
              available: true,
              count: x._count,
              searchValues: [
                isNumber ? searchText || 0 : searchText.toLowerCase(),
              ],
              page: parseInt(xi / 7) + 1,
            };
          })
          .sort(getSort());
        return {
            values: values,
            isActive: isActive,
            column: column,
            columnName: columnDef.text || columnDef.name || columnDef.title,
        }
    },
    populateFilterData(filters, rows) {
        if (filters.length) {
            return filters.map((x) => {
                const fv = this.getFilterValues(rows, x);
                return {
                    value: fv.column,
                    column: fv.column,
                    text: fv.columnName,
                    name: fv.columnName,
                    filterValues: [],
                    listValues: fv.values,
                    listValuesFiltered: fv.values,
                };
            });
        } else {
            return [];
        }
    },
    filterSimilarity(def, rows, matchLevelsAvailable) {
        const matchTypes = [];
        if (def.name_match !== "ignore_name") matchTypes.push(def.name_match);
        if (def.content_match !== "ignore_content") matchTypes.push(def.content_match);
        let matchLevelsUsed = def.matchLevels.map(l => matchLevelsAvailable.find(x => x.name === l)).filter(x => x);
        const result = rows.filter(d => d.tmpl_id === def.tmpl_id 
          && def.statuses.some(s => s === d.doc_status_text)
          && d.matches.some(dm => this.filterLinkedRow(matchLevelsUsed, matchTypes, d, dm)));
        return result;
    },
    filterLinkedRow(matchLevelsUsed, matchTypes, d, dm) {
      if (matchTypes.length && !matchTypes.every(mt => dm[mt])) return false;
      if (matchLevelsUsed.length === 0) return true;
      else
        return matchLevelsUsed.every((x) =>
          x.matchFunction(d, dm, x.matchColumn)
        );
    },
}